module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/3_efaa60c6912071a626a33adce6da3ec5.jpg";